import { AnimatePresence, motion } from "framer-motion";

import { Badge } from "@/components/text/Badge";

export function ProgressStatus({ processType }: { processType: string }) {
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={processType}
        exit={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{
          duration: 0.4,
          ease: [0.4, 0.0, 0.2, 1],
          opacity: { duration: 0.4 },
          y: { duration: 0.4 },
          scale: { duration: 0.4 },
        }}
      >
        <Badge>{processType}</Badge>
      </motion.div>
    </AnimatePresence>
  );
}
